<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="title">基本信息：</div>
      <el-form
        ref="dialogForm"
        :model="dialogForm"
        :rules="formRule"
        label-width="120px"
      >
        <el-form-item label="电台名称" prop="name">
          <el-input
            style="width: 220px"
            v-model="dialogForm.name"
            placeholder="请输入电台名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="icon图标:" prop="fileProp">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
          <el-upload
            :limit="1"
            list-type="picture-card"
            :file-list="fileList"
            action="#"
            accept=".jpg,.jpeg,.png"
            :before-upload="handleChange"
            :http-request="uploadFileHttp"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
          >
            <el-input style="display: none;" v-model="dialogForm.fileProp"></el-input>
            <i class="el-icon-plus"></i>
            <!-- <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div> -->
          </el-upload>
        </el-form-item>
        <el-form-item label="解锁图:" prop="fileProp2">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
          <el-upload
            :limit="1"
            list-type="picture-card"
            :file-list="fileList2"
            action="#"
            accept=".jpg,.jpeg,.png"
            :before-upload="handleChange"
            :http-request="uploadFileHttp2"
            :on-remove="handleRemove2"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
          >
          <el-input style="display: none;" v-model="dialogForm.fileProp2"></el-input>
            <i class="el-icon-plus"></i>
            <!-- <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div> -->
          </el-upload>
        </el-form-item>
        <el-form-item label="未解锁图:" prop="fileProp3">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
          <el-upload
            :limit="1"
            list-type="picture-card"
            :file-list="fileList3"
            action="#"
            accept=".jpg,.jpeg,.png"
            :before-upload="handleChange"
            :http-request="uploadFileHttp3"
            :on-remove="handleRemove3"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
          >
          <el-input style="display: none;" v-model="dialogForm.fileProp3"></el-input>
            <i class="el-icon-plus"></i>
            <!-- <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div> -->
          </el-upload>
        </el-form-item>
        <el-form-item label="电台图像:" prop="fileProp4">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
          <el-upload
            :limit="1"
            list-type="picture-card"
            :file-list="fileList4"
            action="#"
            accept=".jpg,.jpeg,.png"
            :before-upload="handleChange"
            :http-request="uploadFileHttp4"
            :on-remove="handleRemove4"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
          >
          <el-input style="display: none;" v-model="dialogForm.fileProp4"></el-input>
            <i class="el-icon-plus"></i>
            <!-- <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div> -->
          </el-upload>
        </el-form-item>
        <el-form-item label="电台文案">
          <el-input
            style="width: 450px"
            type="textarea"
            rows="5"
            v-model="dialogForm.description"
            placeholder="请输入电台文案"
          ></el-input>
        </el-form-item>
        <el-form-item label="电台音频文件" prop="audioUrl">
          <div class="file-tip">音频文件要求：mp3格式</div>
          <el-upload
            :limit="1"
            :http-request="uploadFile"
            :before-upload="beforeAudioUpload"
            :on-success="handleAudioSuccess"
            :on-error="handleAudioError"
            :show-file-list="true"
            :file-list="fileList5"
            :on-remove="handleRemove5"
            accept=".mp3"
            action="customize"
            :on-exceed="handleExceed2"
          >
            <el-input style="display: none;" v-model="dialogForm.audioUrl"></el-input>
            <el-button size="small" icon="el-icon-upload2" type="primary">上传文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="电台歌词文件" prop="wordUrl">
          <div class="file-tip">歌词文件要求：lrc格式</div>
          <el-upload
            :limit="1"
            :http-request="uploadFile2"
            :before-upload="beforeWordUpload"
            :on-success="handleWordSuccess"
            :on-error="handleWordError"
            :show-file-list="true"
            :file-list="fileList6"
            :on-remove="handleRemove6"
            accept=".lrc"
            action="customize"
            :on-exceed="handleExceed3"
          >
            <el-input style="display: none;" v-model="dialogForm.wordUrl"></el-input>
            <el-button size="small" icon="el-icon-upload2" type="primary">上传文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="上架状态">
          <el-switch
            v-model="dialogForm.status"
          ></el-switch>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number 
            v-model="dialogForm.sortValue"
            :min="1"
            controls-position="right"
            size="small"
          />
        </el-form-item>
        <el-form-item label="电台分类" prop="translate_type_id">
          <el-select v-model="dialogForm.translate_type_id" placeholder="请选择电台类型">
            <el-option
              v-for="item in tableData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="绑定卡牌" class="formItemCard" prop="app_map">
          <el-select
            v-model="dialogForm.org_id"
            placeholder="请选择系列"
          >
            <el-option
              v-for="item in businessList"
              :key="item.org_id"
              :label="item.name"
              :value="item.org_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="dialogForm.org_id"
            placeholder="请选择等级"
          >
            <el-option
              v-for="item in businessList"
              :key="item.org_id"
              :label="item.name"
              :value="item.org_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="dialogForm.org_id"
            placeholder="请选择卡牌"
          >
            <el-option
              v-for="item in businessList"
              :key="item.org_id"
              :label="item.name"
              :value="item.org_id"
            >
            </el-option>
          </el-select>
          <el-button size="small" type="primary">继续添加</el-button>
        </el-form-item> -->
        <el-form-item>
          <span class="dialog-footer">
            <el-button @click="reset">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogForm')">提交</el-button>
          </span>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" custom-class="previewImg">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { getImgName } from "@/utils/cutImgName"
import { getTranslateTypeList, createTranslate, uploadFiles, updateTranslate } from "@/api/radio";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      getImgName,
      businessList: [],
      formRule: {
        name: {
          required: true,
          message: "请输入电台名称",
          trigger: "blur",
        },
        description: {
          required: true,
          message: "请输入电台文案",
          trigger: "blur",
        },
        translate_type_id: {
          required: true,
          message: "请选择电台类型",
          trigger: "blur",
        },
        fileProp: { required: true, message: '请上传文件', trigger: 'change'},
        fileProp2: { required: true, message: '请上传文件', trigger: 'change'},
        fileProp3: { required: true, message: '请上传文件', trigger: 'change'},
        fileProp4: { required: true, message: '请上传文件', trigger: 'change'},
        audioUrl: [
          { required: true, message: '请上传音频文件', trigger: 'change' }
        ],
        wordUrl: [
          { required: true, message: '请上传歌词文件', trigger: 'change' }
        ],

      },
      dialogForm: {
        fileProp: '',
        fileProp2: '',
        fileProp3: '',
        fileProp4: '',
        file_path_list: '',
        file_path_list2: '',
        file_path_list3: '',
        file_path_list4: '',
        file_path_list5: '',
        file_path_list6: '',
        audioUrl: '',
        wordUrl: '',
        name: '',
        translate_type_id: '',
        description: '',
        status: true,
        sortValue: ''
      }, // 模态框展示的数据
      tableData: [],
      OUT_TIMEOUT: 120000, // 出货超时时间为2分钟，即120000毫秒
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      tableData: [],
      type: '',
      id: null,
    };
  },
  created() {
    this.type = this.$route.query.type
    if(this.type == 'edit'){
      let param = JSON.parse(sessionStorage.getItem('radio'))
      console.log(param)
      this.dialogForm.description = param.description
      this.dialogForm.name = param.name
      this.dialogForm.translate_type_id = param.translate_type_id
      this.dialogForm.fileProp = param.icon
      this.dialogForm.fileProp2 = param.lock_pic
      this.dialogForm.fileProp3 = param.unlock_pic
      this.dialogForm.fileProp4 = param.play_pic
      this.dialogForm.file_path_list  = param.icon
      this.dialogForm.file_path_list2  = param.lock_pic
      this.dialogForm.file_path_list3  = param.unlock_pic
      this.dialogForm.file_path_list4  = param.play_pic
      this.dialogForm.audioUrl  = param.audio_file
      this.dialogForm.wordUrl  = param.lyric_file
      this.dialogForm.status = param.status == 1 ? true : false
      this.id = param.id
      this.dialogForm.sortValue = param.order_by
      this.fileList = [
        {
          name: this.getImgName(param.icon),
          url: param.icon,
        },
      ]
      this.fileList2 = [
        {
          name: this.getImgName(param.lock_pic),
          url: param.lock_pic,
        },
      ]
      this.fileList3 = [
        {
          name: this.getImgName(param.unlock_pic),
          url: param.unlock_pic,
        },
      ]
      this.fileList4 = [
        {
          name: this.getImgName(param.play_pic),
          url: param.play_pic,
        },
      ]
      this.fileList5 = [
        {
          name: this.getImgName(param.audio_file),
          url: param.audio_file,
        },
      ]
      this.fileList6 = [
        {
          name: this.getImgName(param.lyric_file),
          url: param.lyric_file,
        },
      ]
    } else {
      this.dialogForm.sortValue = Number(this.$route.query.length) + 1
    }
  },
  mounted() {
    this.getTranslateTypeList()
  },

  methods: {
    // getImgName(str){
    //   let arr = str.split('.')
    //   return arr[arr.length - 2] + '.' + arr[arr.length - 1]
    // },
    
    getTranslateTypeList(){
      getTranslateTypeList().then((res) => {
        if (res && res.data) {
          this.tableData = res.data
        }
      })
    },
    uploadFileHttp(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.file_path_list = res.data.filePath
          this.dialogForm.fileProp = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove()
      })
    },
    uploadFileHttp2(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.file_path_list2 = res.data.filePath
          this.dialogForm.fileProp2 = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove2()
      })
    },
    uploadFileHttp3(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.file_path_list3 = res.data.filePath
          this.dialogForm.fileProp3 = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove3()
      })
    },
    uploadFileHttp4(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.file_path_list4 = res.data.filePath
          this.dialogForm.fileProp4 = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove4()
      })
    },
    uploadFile(params){
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.audioUrl = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove5()
      })
    },
    uploadFile2(params){
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.wordUrl = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove6()
      })
    },
    handleChange(file) {
      const isLt5M = file.size / 1024 / 1024 < 2;
      if (!isLt5M) {
        this.$message({
          showClose: true,
          message: "文件大小不能超过 2MB",
          type: "warning",
        });
        return false;
      }
    },
    beforeAudioUpload(file) {
      const isAudio = file.type.startsWith('audio/');
      const isLt10M = file.size / 1024 / 1024 < 10;
      
      if (!isAudio) {
        this.$message.error('只能上传音频文件!');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('音频大小不能超过10MB!');
        return false;
      }
      return true;
    },
    beforeWordUpload(file) {
      const isLRC = file.name.toLowerCase().endsWith('.lrc');
      if (!isLRC) {
        this.$message.error('只能上传 LRC 格式的文件!');
        return false; // 阻止上传
      }
      return true;
    },
    handleAudioSuccess(response, file) {
      this.dialogForm.audioUrl = URL.createObjectURL(file.raw);
      this.$refs.dialogForm.validateField('audioUrl')
    },
    handleWordSuccess(response, file) {
      this.dialogForm.wordUrl = URL.createObjectURL(file.raw);
      this.$refs.dialogForm.validateField('wordUrl')
    },
    handleAudioError(err, file) {
      this.$message.error('音频上传失败: ' + err.message)
    },
    handleWordError(err, file) {
      this.$message.error('歌词上传失败: ' + err.message)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.dialogForm.fileProp = ''
      this.dialogForm.file_path_list = ''
    },
    handleRemove2(file, fileList) {
      this.fileList2 = fileList
      this.dialogForm.fileProp2 = ''
      this.dialogForm.file_path_list2 = ''
    },
    handleRemove3(file, fileList) {
      this.fileList3 = fileList
      this.dialogForm.fileProp3 = ''
      this.dialogForm.file_path_list3 = ''
    },
    handleRemove4(file, fileList) {
      this.fileList4 = fileList
      this.dialogForm.fileProp4 = ''
      this.dialogForm.file_path_list4 = ''
    },
    handleRemove5(file, fileList){
      this.dialogForm.audioUrl = ''
      this.fileList5 = fileList
      this.dialogForm.file_path_list5 = ''
    },
    handleRemove6(file, fileList){
      this.dialogForm.wordUrl = ''
      this.fileList6 = fileList
      this.dialogForm.file_path_list6 = ''
    },
    // 文件超出限制时触发
    handleExceed() {
      this.$message.warning('只能上传一张图片，请重新选择！')
    },
    handleExceed2() {
      this.$message.warning('只能上传一份音频，请重新选择！')
    },
    handleExceed3() {
      this.$message.warning('只能上传一份歌词，请重新选择！')
    },

    // 点击退款按钮，弹出弹窗
    reset(row, index) {
      this.$router.go(-1)
    },
    submitForm() {
      if(this.type == 'add'){
        let param = {
          name: this.dialogForm.name,
          icon: this.dialogForm.file_path_list,
          lock_pic: this.dialogForm.file_path_list2,
          unlock_pic: this.dialogForm.file_path_list3,
          description: this.dialogForm.description,
          play_pic: this.dialogForm.file_path_list4,
          audio_file: this.dialogForm.audioUrl,
          lyric_file: this.dialogForm.wordUrl,
          order_by: this.dialogForm.sortValue,
          status: this.dialogForm.status ? 1 : 0,
          translate_type_id: this.dialogForm.translate_type_id,
        }
        console.log(param)
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              createTranslate(param).then(res => {
                console.log(res)
                if(res.data){
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      } else {
        let param = {
          name: this.dialogForm.name,
          icon: this.dialogForm.file_path_list,
          lock_pic: this.dialogForm.file_path_list2,
          unlock_pic: this.dialogForm.file_path_list3,
          description: this.dialogForm.description,
          play_pic: this.dialogForm.file_path_list4,
          audio_file: this.dialogForm.audioUrl,
          lyric_file: this.dialogForm.wordUrl,
          order_by: this.dialogForm.sortValue,
          status: this.dialogForm.status ? 1 : 0,
          translate_type_id: this.dialogForm.translate_type_id,
          id: this.id
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateTranslate(param).then(res => {
                console.log(res)
                if(res.data){
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      }
    },
    handlePictureCardPreview(file){
      this.dialogImageUrl = file.url;
      this.dialogVisible = true
    }
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: 700;
}
.titlas {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.tips {
  color: red;
  font-size: 16px;
  font-weight: 600;
}
.file-tip{
  color: red;
  font-weight: 600;
}
// .el-form{
//   ::v-deep .el-upload-list{
//     width: 500px;
//   }
// }

.formItemCard{
  .el-select{
    margin-right: 12px;
  }
}
</style>
